'use strict';

var _extends = require('../../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Tab = require('../../Tabs/Tab.js');
var withStyles = require('../../../Styles/withStyles.js');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles(theme) {
  return {
    root: {
      minWidth: 60,
      textTransform: 'capitalize',
      margin: 0,
      height: 64,
      fontSize: 12,
      fontWeight: 500,
      opacity: 1,
      backgroundColor: 'transparent !important'
    },
    labelContainer: {
      padding: '6px 10px 0 10px'
    }
  };
};

var AppBarTab = function AppBarTab(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      icon = _ref.icon,
      props = objectWithoutProperties(_ref, ["classes", "label", "icon"]);

  return React__default["default"].createElement(Tab, _extends["default"]({
    label: label,
    icon: icon,
    textColor: "disabled",
    classes: {
      root: classNames__default["default"](classes.root),
      labelContainer: classes.labelContainer
    }
  }, props));
};

var AppBarTab$1 = withStyles["default"](styles)(AppBarTab);

module.exports = AppBarTab$1;
